// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hj-0";